import isType from './is-type';
export default (function (value) {
  return Array.isArray ? Array.isArray(value) : isType(value, 'Array');
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/is-array.js
// module id = 0
// module chunks = 0